module.exports = __webpack_public_path__ + "assets/img/按钮光效.a8d60014.png";